import { render, staticRenderFns } from "./SignUpPage.vue?vue&type=template&id=d9ab164e&scoped=true"
import script from "./SignUpPage.vue?vue&type=script&lang=js"
export * from "./SignUpPage.vue?vue&type=script&lang=js"
import style0 from "./SignUpPage.vue?vue&type=style&index=0&id=d9ab164e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9ab164e",
  null
  
)

export default component.exports